export const defaultApiPath: string = '/api/'

export const serverHost: string | undefined = process.env.REACT_APP_BACKEND_HOST
export const serverApiPath: string | undefined = process.env.REACT_APP_BACKEND_API_PATH